<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['logotypes']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title']
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'logotypes'],
              items: this.form.logotypes.map((item, i) => ({
                headerLabel: get(item.link, ['url']),
                fields: [
                  new fields.Image({
                    label: 'Zdjęcie',
                    required: true,
                    modelPath: [this, 'form', 'logotypes', i, 'image'],
                    help: 'Zalecany format logotypu: svg.'
                  }),
                  new fields.Link({
                    label: 'Link',
                    modelPath: [this, 'form', 'logotypes', i, 'link'],
                    required: true
                  }),
                  new fields.Input({
                    label: 'Szerokość',
                    type: 'number',
                    modelPath: [this, 'form', 'logotypes', i, 'width'],
                    help: 'Domyślnie: 150'
                  }),
                  new fields.Input({
                    label: 'Wysokość',
                    type: 'number',
                    modelPath: [this, 'form', 'logotypes', i, 'height'],
                    help: 'Domyślnie: 50'
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  },
  watch: {
    'form.logotypes': {
      immediate: true,
      deep: true,
      handler: function (logotypes) {
        logotypes.forEach(logotype => {
          if (logotype.width === '') {
            logotype.width = null
          }
          if (logotype.height === '') {
            logotype.height = null
          }
        })
      }
    }
  }
}
</script>
